var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDlr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5236 3.64645L13.3771 3.5H13.17H6H5.5V4V20V20.5H6H18H18.5V20V8.83V8.62289L18.3536 8.47645L13.5236 3.64645ZM13 9.5H14.5V10.5H11H10.5V11V12V12.5H11H14C14.2739 12.5 14.5 12.7261 14.5 13V16C14.5 16.2739 14.2739 16.5 14 16.5H13H12.5V17V17.5H11.5V17V16.5H11H9.5V15.5H13H13.5V15V14V13.5H13H10C9.72614 13.5 9.5 13.2739 9.5 13V10C9.5 9.72614 9.72614 9.5 10 9.5H11H11.5V9V8.5H12.5V9V9.5H13ZM6 2.5H13.7929L19.5 8.20711V20C19.5 20.8239 18.8239 21.5 18 21.5H6C5.17614 21.5 4.5 20.8239 4.5 20V4C4.5 3.17614 5.17614 2.5 6 2.5Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlr);
export default __webpack_public_path__ + "static/media/dlr.ab39b3bdfcd89ec66f978dda3bd1634d.svg";
export { ForwardRef as ReactComponent };